<template>
  <div>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" lg="8" offset-lg="2" xl="8" offset-xl="2">
        <v-card flat align="center" class="mb-10 pa-4">
          <v-card-text>
            <v-icon x-large color="red">mdi-alert-circle</v-icon>
            <h2 class="h2 my-4 red--text">
              Ihre Bestellung konnte nicht übermittelt werden.
            </h2>
            Bitte versuchen Sie es später erneut oder kontaktieren Sie uns unter
            mail@heberlein-kraeutertee.de
          </v-card-text>
          <v-card-actions class="mt-6">
            <v-spacer />
            <v-btn small text color="greenb" to="/">
              Zurück zur Startseite
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {};
</script>
